import updateTaskDetailUseCase from "./updateTaskDetailUseCase"

const updateParamsBudgetUseCase = (task, refill, manPower) => {
    const detail = { ...task.detail, refill, manPower }
    return updateTaskDetailUseCase(task.data.id, detail)
}

export default updateParamsBudgetUseCase